import type { Feedback as FeedbackType } from 'app/typings/adminBookings/bookingFeedback';
import type {
  BookingDetails,
  BookingVoucherResponse,
} from 'app/typings/core/admin/bookings/booking';
import { BOOKING_STATUS } from 'app/typings/core/admin/bookings/enum/bookingStatus';

import { CancelModal } from './CancelBooking';
import { EditEmail } from './EditEmail';
import { EditReview } from './EditReview';
import { RefundBooking } from './RefundBooking';
import { Voucher } from './Voucher';

type Props = {
  bookingDetails: BookingDetails;
  bookingCode: string;
  reloadBooking: () => void;
  refundModalVisible: boolean;
  onCloseRefundModal: () => void;
  isVccDebited: boolean;
  selectedVoucher?: BookingVoucherResponse;
  isVoucherModalVisible: boolean;
  onCloseVoucherModal: () => void;
  isEditEmailModalVisible: boolean;
  setIsEditEmailModalVisible: (isVisible: boolean) => void;
  isCancelModalVisible: boolean;
  setIsCancelModalVisible: (bool: boolean) => void;
  feedbackInModal: FeedbackType | undefined;
  onCloseFeedbackModal: () => void;
  isEditReviewModalVisible: boolean;
  setIsEditReviewModalVisible: (isVisible: boolean) => void;
  editReviewId: number | undefined;
};

export const BookingModals = ({
  bookingDetails,
  bookingCode,
  reloadBooking,
  refundModalVisible,
  onCloseRefundModal,
  isVccDebited,
  selectedVoucher,
  isVoucherModalVisible,
  onCloseVoucherModal,
  isEditEmailModalVisible,
  setIsEditEmailModalVisible,
  isCancelModalVisible,
  setIsCancelModalVisible,
  feedbackInModal,
  onCloseFeedbackModal,
  isEditReviewModalVisible,
  setIsEditReviewModalVisible,
  editReviewId,
}: Props) => {
  return (
    <>
      <EditEmail
        bookingDetails={bookingDetails}
        isEditEmailModalVisible={isEditEmailModalVisible}
        setIsEditEmailModalVisible={setIsEditEmailModalVisible}
      />

      <CancelModal
        isModalOpen={isCancelModalVisible}
        setIsModalOpen={setIsCancelModalVisible}
        code={bookingCode}
      />

      {editReviewId && (
        <EditReview
          reviewDetails={bookingDetails.reviews.find(
            (review) => review.id === editReviewId
          )}
          isEditReviewModalVisible={isEditReviewModalVisible}
          setIsEditReviewModalVisible={setIsEditReviewModalVisible}
          bookingCode={bookingCode}
        />
      )}

      <RefundBooking
        bookingCode={bookingCode}
        bookingId={bookingDetails.id}
        refundModalVisible={refundModalVisible}
        onCloseRefundModal={onCloseRefundModal}
        isBookingCanceled={bookingDetails.status === BOOKING_STATUS.CANCELED}
      />

      <Voucher
        key={`${selectedVoucher?.code ?? 'create'}-${isVoucherModalVisible}`}
        bookingDetails={bookingDetails}
        voucher={selectedVoucher}
        isVoucherModalVisible={isVoucherModalVisible}
        onCloseVoucherModal={onCloseVoucherModal}
      />
    </>
  );
};
